import React, { useState, useRef, useEffect, useCallback } from "react";
import ReactDOM from "react-dom";

const CustomTooltip = ({
  children,
  content,
  position = "top",
  className = "",
}) => {
  const [show, setShow] = useState(false);
  const [coords, setCoords] = useState({ top: 0, left: 0 });
  const targetRef = useRef(null);

  const calculatePosition = useCallback(() => {
    if (!targetRef.current) return;
    const rect = targetRef.current.getBoundingClientRect();
    const scrollLeft = window.scrollX || document.documentElement.scrollLeft;
    const scrollTop = window.scrollY || document.documentElement.scrollTop;

    let top = rect.top + scrollTop;
    let left = rect.left + scrollLeft;

    switch (position) {
      case "top":
        top -= 4; // Offset for arrow/space
        left += rect.width / 2;
        break;
      case "bottom":
        top += rect.height + 4;
        left += rect.width / 2;
        break;
      case "left":
        top += rect.height / 2;
        left -= 8;
        break;
      case "right":
        top += rect.height / 2;
        left += rect.width + 4;
        break;
      default:
        break;
    }

    setCoords({ top, left });
  }, [position]);

  const handleMouseEnter = () => {
    calculatePosition();
    setShow(true);
  };

  const handleMouseLeave = () => {
    setShow(false);
  };

  useEffect(() => {
    if (show) {
      window.addEventListener("scroll", calculatePosition);
      window.addEventListener("resize", calculatePosition);
    }
    return () => {
      window.removeEventListener("scroll", calculatePosition);
      window.removeEventListener("resize", calculatePosition);
    };
  }, [show, calculatePosition]);

  return (
    <>
      {React.cloneElement(React.Children.only(children), {
        ref: targetRef,
        onMouseEnter: handleMouseEnter,
        onMouseLeave: handleMouseLeave,
      })}
      {show &&
        ReactDOM.createPortal(
          <div
            className={`custom-portal-tooltip tooltip-${position} ${className}`}
            style={{
              position: "absolute",
              top: `${coords.top}px`,
              left: `${coords.left}px`,
              zIndex: 10000,
              pointerEvents: "none",
            }}
          >
            <div className="tooltip-content">{content}</div>
          </div>,
          document.body,
        )}
    </>
  );
};

export default CustomTooltip;
